import React, {useState} from "react";

const clamp = (value: number, min: number, max: number) =>
    Math.min(max, Math.max(min, value));

export function useZoomPan() {
    const [zoom, setZoom] = useState(1);
    const [pan, setPan] = useState({x: 0, y: 0});
    const [isPanning, setIsPanning] = useState(false);

    const handleWheel: React.WheelEventHandler<HTMLDivElement> = (e) => {
        e.preventDefault();
        const delta = -e.deltaY;
        const zoomStep = 0.0015;
        setZoom((prev) => clamp(prev + delta * zoomStep, 0.4, 4));
    };

    const zoomIn = () => setZoom((z) => clamp(z * 1.2, 0.4, 4));
    const zoomOut = () => setZoom((z) => clamp(z / 1.2, 0.4, 4));
    const resetView = () => {
        setZoom(1);
        setPan({x: 0, y: 0});
    };

    const handleMouseDown: React.MouseEventHandler<HTMLDivElement> = (e) => {
        if (e.button !== 0) return;
        setIsPanning(true);
    };
    const handleMouseUp: React.MouseEventHandler<HTMLDivElement> = () => setIsPanning(false);
    const handleMouseLeave: React.MouseEventHandler<HTMLDivElement> = () => setIsPanning(false);
    const handleMouseMove: React.MouseEventHandler<HTMLDivElement> = (e) => {
        if (!isPanning) return;
        setPan((prev) => ({
            x: prev.x + e.movementX / zoom,
            y: prev.y + e.movementY / zoom,
        }));
    };

    const transformStyle = (width: number, height: number) =>
        `translate(${width / 2 + pan.x}, ${height / 2 + pan.y}) scale(${zoom}) translate(${-width / 2}, ${-height / 2})`;

    return {
        zoom,
        pan,
        isPanning,
        handleWheel,
        zoomIn,
        zoomOut,
        resetView,
        handleMouseDown,
        handleMouseUp,
        handleMouseLeave,
        handleMouseMove,
        transformStyle,
    };
}
